import { UpdateWaypoint } from '@course-planning-store';

export default [UpdateWaypoint.type];
